import { boot } from 'quasar/wrappers'
import { setCommonDefaults } from 'src/componentDefaults'
import ariaInvalid from '@wilken/portal-ui-common/directives/ariaInvalid.js'
import itemAutoRole from '@wilken/portal-ui-common/directives/itemAutoRole.js'
import QItemStandalone from '@wilken/portal-ui-common/components/overrides/QItemStandalone.js'

export default boot(({ app }) => {
  app.component(QItemStandalone.name, QItemStandalone)
  // common component defaults
  setCommonDefaults()

  if (app) {
    app.directive('aria-invalid', ariaInvalid)
    app.directive('item-auto-role', itemAutoRole)
  }
})
